import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { LogoLockup } from "../../components/brand/Brand";
import { LayoutGrid, Building2, CalendarClock, Download, LogOut } from "lucide-react";

const nav = [
  { to: "/app", label: "Dashboard", icon: LayoutGrid, end: true },
  { to: "/app/businesses", label: "Businesses", icon: Building2 },
  { to: "/app/follow-ups", label: "Follow-ups", icon: CalendarClock },
  { to: "/app/export", label: "Export", icon: Download },
];

export default function FounderLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <aside className="md:w-64 md:flex-shrink-0 border-b md:border-b-0 md:border-r hairline bg-lr-card/70 md:min-h-screen flex md:flex-col">
        <div className="p-5 hidden md:block"><LogoLockup /></div>
        <div className="p-4 md:hidden"><LogoLockup compact /></div>
        <nav className="flex md:flex-col gap-1 px-3 md:px-3 overflow-x-auto flex-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-[4px] text-sm whitespace-nowrap transition-colors ${
                  isActive ? "bg-lr-olive text-lr-cream" : "text-lr-charcoal/80 hover:bg-lr-olive/10"
                }`}>
              <n.icon className="h-4 w-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 md:mt-auto border-t hairline hidden md:block">
          <div className="text-xs text-lr-leather px-2 mb-2 truncate">{user?.name} · {user?.email}</div>
          <button onClick={() => { logout(); navigate("/login"); }} data-testid="logout-btn"
            className="flex items-center gap-2 text-sm text-lr-leather hover:text-lr-clay px-2 py-1.5 transition-colors">
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
        <button onClick={() => { logout(); navigate("/login"); }} data-testid="logout-btn-mobile"
          className="md:hidden flex items-center gap-2 text-sm text-lr-leather px-4"><LogOut className="h-4 w-4" /></button>
      </aside>
      <main className="flex-1 min-w-0 lr-scroll overflow-x-hidden"><Outlet /></main>
    </div>
  );
}
